<template>
  <div class="florpt">
    <div class="appHelmetwd">楼层<img src="../../public/obraoag/appReturn.png" alt="" @click="appHelmetreturn()"></div>
    <div class="hotb-let">
      <div class="hotb-let-nr" v-for="(wdym,index) in flavtn" :key = wdym.index @click="table(index)" :class="num == index ? 'hotb-let-nrmr' : ''">
        <p class="hotb-let-nrbk florpt-let-nr" @click="tabsj(index)">{{wdym}}<span>层</span></p>
      </div>
    </div>
    <div class="hotb-rig">
      <div class="yllb-xztp">
        <img src="../../public/obraoag/homelb.png" alt="" class="carousel-img">
      </div>
      <div class="hotb-marn">
        <div class="florpt-conter" v-for="sbzzxca in wdzd" :key = sbzzxca.ID> 
          <router-link :to="{path:'details',query:{commid: sbzzxca.ID}}">
            <div class="florpt-conter-tp">
              <img :src="sbzzxca.COMPANY_SMALL_URL"  alt="">
            </div>
            <div class="florpt-conter-nr">{{sbzzxca.COMPANY_NAME}}</div>
          </router-link>
        </div>
      </div>
    </div>
    <!-- 加载中 -->
    <PageLong :style="'display:' + outelong"></PageLong>
  </div>
</template>

<script>
import "./obraojs/rem"
export default {
  data () {
    return{
      wdzd: '',
      num: 0,
      customerID: '',
      OuQuanty: '',
      outelong: 'block',
      flavtn: ['B1','F1','F2','F3','F4','F5','F6','F7']
    }
  },
  created () {
    this.$axios.post('wx/floorpoint',this.$qs.stringify({
      FLOOR: '0'
    }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      this.outelong = 'none';
      this.wdzd = res.data.data;
    })
    .catch(() => {
      console.log('获取失败');
    });
  },
  mounted () {

  },
  methods: {
    table(index) {
      this.num = index;
    },
    tabsj(flsj) {
      this.outelong = 'block';
      this.$axios.post('wx/floorpoint',this.$qs.stringify({
        FLOOR: flsj
      }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
      .then(res => {
        this.outelong = 'none';
        this.wdzd = res.data.data;
      })
      .catch(() => {
        console.log('获取失败');
      });
    },
    // 点击返回上一层
    appHelmetreturn(){
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped>
  @import "obraocs/outlets.css";
</style>